"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncientElvenSliceAbilityHandler = exports.AncientElvenSliceActorAbilityFactory = exports.AncientElvenSliceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Damage_1 = require("../../core/Damage");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const ActorType_1 = require("../../core/actors/ActorType");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class AncientElvenSliceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AncientElvenSlice;
        this.__typeName = "AncientElvenSlice";
    }
}
exports.AncientElvenSliceAbilityArgs = AncientElvenSliceAbilityArgs;
let AncientElvenSliceActorAbilityFactory = class AncientElvenSliceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AncientElvenSlice", "OneEnemies", 0);
    }
};
AncientElvenSliceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AncientElvenSlice")
], AncientElvenSliceActorAbilityFactory);
exports.AncientElvenSliceActorAbilityFactory = AncientElvenSliceActorAbilityFactory;
let AncientElvenSliceAbilityHandler = class AncientElvenSliceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            attackerId: ability.invokerId,
            targetId,
            abilityKey: "AncientElvenSlice",
            attackType: "melee",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ],
            onHit: (sequence, _attack, damages) => {
                container.applyDebuffs({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    effects: [
                        {
                            duration: Duration_1.Duration.Turns(3),
                            effect: new core_1.BleedingEffectArgs("Power", 10),
                        },
                        (0, Random_1.randomPercent)() <= 70 && {
                            duration: Duration_1.Duration.Turns(1),
                            effect: new core_1.StunEffectArgs()
                        }
                    ].filter(Boolean)
                });
                const totalDamage = Damage_1.Damage.Sum(damages);
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId: ability.invokerId,
                    amount: totalDamage
                });
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .filter(id => { var _a; return ((_a = container.getActor(id)) === null || _a === void 0 ? void 0 : _a.classType) === ActorType_1.ActorType.LordZug; })
                    .forEach(lordZug => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: lordZug,
                        duration: Duration_1.Duration.Turns(3),
                        effect: new core_1.DamageAbsorbEffectArgs({
                            [enums_1.DamageType.All]: Math.round(totalDamage)
                        }, Number.MAX_SAFE_INTEGER)
                    });
                });
            }
        });
    }
};
AncientElvenSliceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AncientElvenSlice)
], AncientElvenSliceAbilityHandler);
exports.AncientElvenSliceAbilityHandler = AncientElvenSliceAbilityHandler;
